// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-assistant {
    display: flex;
    flex-direction: column;
    height: 500px;
    background-color: var(--surface-ground);
    border-radius: 8px;
    padding: 1rem;
}

.chat-messages {
    flex: 1 1;
    overflow-y: auto;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.welcome-message {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
}

.message {
    display: flex;
    margin-bottom: 0.5rem;
}

.message.user {
    justify-content: flex-end;
}

.message.assistant {
    justify-content: flex-start;
}

.message-content {
    max-width: 70%;
    padding: 0.75rem 1rem;
    border-radius: 1rem;
    position: relative;
}

.message.user .message-content {
    background-color: var(--primary-color);
    color: var(--primary-color-text);
    border-top-right-radius: 0.25rem;
}

.message.assistant .message-content {
    background-color: var(--surface-card);
    border-top-left-radius: 0.25rem;
}

.message.system .message-content {
    background-color: var(--red-100);
    color: var(--red-900);
    border-radius: 0.5rem;
    margin: 0 auto;
}

.message-timestamp {
    font-size: 0.75rem;
    opacity: 0.7;
    margin-top: 0.25rem;
}

.chat-input {
    display: flex;
    gap: 0.5rem;
    padding-top: 1rem;
    border-top: 1px solid var(--surface-border);
}

.chat-input .p-inputtext {
    flex: 1 1;
}

.typing-indicator {
    display: flex;
    gap: 0.25rem;
    padding: 0.25rem 0;
}

.typing-indicator span {
    width: 0.5rem;
    height: 0.5rem;
    background-color: var(--primary-color);
    border-radius: 50%;
    animation: typing 1s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) { animation-delay: 0.2s; }
.typing-indicator span:nth-child(2) { animation-delay: 0.3s; }
.typing-indicator span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typing {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-0.5rem); }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatAssistant.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA,sCAAsC,qBAAqB,EAAE;AAC7D,sCAAsC,qBAAqB,EAAE;AAC7D,sCAAsC,qBAAqB,EAAE;;AAE7D;IACI,WAAW,wBAAwB,EAAE;IACrC,MAAM,8BAA8B,EAAE;AAC1C","sourcesContent":[".chat-assistant {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 500px;\r\n    background-color: var(--surface-ground);\r\n    border-radius: 8px;\r\n    padding: 1rem;\r\n}\r\n\r\n.chat-messages {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 1rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.welcome-message {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.message {\r\n    display: flex;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.message.user {\r\n    justify-content: flex-end;\r\n}\r\n\r\n.message.assistant {\r\n    justify-content: flex-start;\r\n}\r\n\r\n.message-content {\r\n    max-width: 70%;\r\n    padding: 0.75rem 1rem;\r\n    border-radius: 1rem;\r\n    position: relative;\r\n}\r\n\r\n.message.user .message-content {\r\n    background-color: var(--primary-color);\r\n    color: var(--primary-color-text);\r\n    border-top-right-radius: 0.25rem;\r\n}\r\n\r\n.message.assistant .message-content {\r\n    background-color: var(--surface-card);\r\n    border-top-left-radius: 0.25rem;\r\n}\r\n\r\n.message.system .message-content {\r\n    background-color: var(--red-100);\r\n    color: var(--red-900);\r\n    border-radius: 0.5rem;\r\n    margin: 0 auto;\r\n}\r\n\r\n.message-timestamp {\r\n    font-size: 0.75rem;\r\n    opacity: 0.7;\r\n    margin-top: 0.25rem;\r\n}\r\n\r\n.chat-input {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid var(--surface-border);\r\n}\r\n\r\n.chat-input .p-inputtext {\r\n    flex: 1;\r\n}\r\n\r\n.typing-indicator {\r\n    display: flex;\r\n    gap: 0.25rem;\r\n    padding: 0.25rem 0;\r\n}\r\n\r\n.typing-indicator span {\r\n    width: 0.5rem;\r\n    height: 0.5rem;\r\n    background-color: var(--primary-color);\r\n    border-radius: 50%;\r\n    animation: typing 1s infinite ease-in-out;\r\n}\r\n\r\n.typing-indicator span:nth-child(1) { animation-delay: 0.2s; }\r\n.typing-indicator span:nth-child(2) { animation-delay: 0.3s; }\r\n.typing-indicator span:nth-child(3) { animation-delay: 0.4s; }\r\n\r\n@keyframes typing {\r\n    0%, 100% { transform: translateY(0); }\r\n    50% { transform: translateY(-0.5rem); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
